import { afterGet as globalAfterGet } from "services/sosInventoryService/afterGet";
import {
  FIELDS_TO_TRANSFORM,
  QUICK_LIST_FIELDS_TO_TRANSFORM,
} from "services/sosInventoryService/customer/schema";
import { transformFields } from "services/utility/afterGet";

import globalState from "globalState/globalState";

export function afterGet(record) {
  const newRecord = transformFields(record, FIELDS_TO_TRANSFORM);

  const { allowPlusFeatures } =
    globalState.getState().userCompanySettings.settings;
  if (!allowPlusFeatures) {
    // Remove price tier for companion plans.
    // It may exist from a previous plan, but companion plans ignore it.
    // Setting newRecord.priceTier to null ensures the frontend doesn't use it in pricing.
    newRecord.priceTier = null;
  }

  return globalAfterGet(newRecord);
}

export function quickListAfterGet(record) {
  return transformFields(record, QUICK_LIST_FIELDS_TO_TRANSFORM);
}
